// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"style_mainDiv__2zoZ9","understoodBtn":"style_understoodBtn__M0ynG","logoutImg":"style_logoutImg__32A6w"};